const initialState = {
  currentUser:null
};

export default initialState;
